import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";

import { useGetDrivers } from "../../apis";
import { GetDriversListRequestParams } from "./useDriversList.types";

const useDriversList = (params?: GetDriversListRequestParams) => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    showDeletedOnly,
    setShowDeletedOnly
  } = useManageTable();

  const requestParams: GetDriversListRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch,
      orderBy: sorting[0]?.id ?? null,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "ASC",
      isDeleted: showDeletedOnly,
      ...params
    }),
    // JSON.stringify(params) so a changed filter (e.g. deliveryCompanyId when
    // the order modal switches company) actually recomputes the request and
    // refetches the right company's drivers instead of the previous one.
    [page, debouncedSearch, sorting, showDeletedOnly, JSON.stringify(params)]
  );

  const {
    drivers,
    meta,
    isLoading,
    refetch: refetchDrivers,
    setDrivers
  } = useGetDrivers(requestParams);

  return {
    drivers,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    refetchDrivers,
    setDrivers,
    showDeletedOnly,
    setShowDeletedOnly
  };
};

export default useDriversList;
